<template>
    <div class="dashboard" app>
        <Navbar />
        <v-content>
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        :color="customization.mainBtnColor"
                        :style="`color: ${customization.topBarColor}`"
                        fab
                        large
                        bottom
                        right
                        dark
                        fixed
                        v-bind="attrs"
                        v-on="on"
                        @click="recarregar()"
                    >
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </template>
                <span>Recarregar Dados</span>
            </v-tooltip>
            <v-row style="padding: 16px 16px; margin-top: -10px">
                <v-col cols="6" md="3" style="float: right;padding: 3px 10px" v-if="filters">
                    <v-btn
                        :color="customization.mainBtnColor"
                        :dark="customization.mainBtnDark"
                        @click="dialog_filtros = true"
                        width="100%">
                        Filtros
                    </v-btn>
                </v-col>
            </v-row> 
            <v-row align="center" justify="center" style="padding: 16px 16px; margin-top: -10px">
                 <v-dialog
                    v-model="dialog_filtros"
                    max-width="500px"
                    @seeked="dialog_filtros = false"
                >
                    <v-card style="padding: 8px 12px" :dark="false">
                        <v-row align="center" justify="center">
                            <v-col cols="12" style="padding: 10px 10px" v-if="filters">
                                <v-btn
                                    style="float:right"
                                    icon
                                    @click="dialog_filtros = false">
                                    <v-icon>
                                        mdi-close
                                    </v-icon>
                                </v-btn>
                                <h2>Filtros:</h2>
                            </v-col>
                            <v-col cols="12" style="padding: 0px 10px" v-if="filters">
                                <v-combobox
                                    v-model="filtro.materiais"
                                    :items="materiais"
                                    label="Item PQ"
                                    multiple
                                    chips
                                    outlined
                                    dense
                                    auto-select-first
                                    return-object
                                    item-text="descricao"
                                    item-value="iditempq"
                                    hide-details
                                ></v-combobox>
                            </v-col>
                            <v-col cols="12"  style="padding: 5px 10px" v-if="filters">
                                <v-combobox
                                    v-model="filtro.area"
                                    :items="areas"
                                    label="Estruturas"
                                    multiple
                                    dense
                                    chips
                                    auto-select-first
                                    outlined
                                    return-object
                                    item-text="descricao"
                                    item-value="idestrutura"
                                    hide-details
                                ></v-combobox>
                            </v-col>
                            <v-col cols="12"  style="padding: 5px 10px" v-if="filters">
                                <v-combobox
                                    v-model="filtro.equipes"
                                    :items="equipes"
                                    label="Equipe"
                                    multiple
                                    dense
                                    chips
                                    auto-select-first
                                    outlined
                                    return-object
                                    item-text="descricao"
                                    item-value="idequipe"
                                    hide-details
                                ></v-combobox>
                            </v-col>
                            <v-col cols="12" style="padding: 0px 10px" v-if="filters">
                                <v-combobox
                                    v-model="filtro.turno"
                                    :items="turnos"
                                    label="Turno"
                                    multiple
                                    dense
                                    chips
                                    auto-select-first
                                    outlined
                                    return-object
                                    item-text="descricao"
                                    item-value="idturno"
                                    hide-details
                                ></v-combobox>
                            </v-col>
                            <v-col cols="12" style="padding: 5px 10px" v-if="filters">
                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="dates"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="getFormatingDates()"
                                        label="Data"
                                        outlined
                                        dense
                                        hide-details
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dates"
                                        locale="pt-br"
                                        :allowed-dates="allowedDates"
                                        range
                                        no-title
                                        scrollable
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="dates = []"
                                    >
                                        Limpar
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menu = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        text
                                        :color="customization.mainBtnColor"
                                        :dark="customization.mainBtnDark"
                                        @click="$refs.menu.save(dates)"
                                    >
                                        Aplicar
                                    </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6" style="padding: 5px 10px" v-if="filters">
                                
                                <v-radio-group v-model="descarga">
                                    <v-radio
                                        :label="`Qtd.`"
                                        :value="false"
                                    ></v-radio>
                                    <v-radio
                                        :label="`Qtd. Linear`"
                                        :value="true"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12" sm="6" style="padding: 0px 10px" v-if="filters">
                                <v-checkbox v-model="reloading_charts" label="Recarregar todas as informações em 10 minutos" />
                            </v-col>
                            <v-col cols="12" style="padding: 0px 10px" v-if="filters">
                                <v-btn
                                    large
                                    width="100%"
                                    :color="customization.mainBtnColor"
                                    :dark="customization.mainBtnDark"
                                    @click="filtrar">
                                    Filtrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                 </v-dialog>
                <v-col
                    v-for="(d,i) in dashboard_items"
                    :key="`dashboard_${i}`"
                    :lg="d.size.lg || null"
                    :md="d.size.md || null"
                    :sm="d.size.sm || null"
                    :cols="d.size.cols ? d.size.cols : null">
                    <v-card
                        :dark="customization.dark"
                        :loading="dashboard_loading[i]"
                        :height="(d.content.chart && ['tableArea','horizontal','double'].includes(d.content.chart.type)) ? 'auto' : ((d.content.chart && d.content.chart.type == 'ranking') || !d.content.chart) ? '390px' : '430px'"
                        outlined>
                        <v-img
                            v-if="d.header"
                            :src="d.header.src"
                            :height="d.header.height ? d.header.height : '200px'"
                        ></v-img>
                        <v-card-title class="headline" style="font-size: 17px !important">{{d.content.title}}</v-card-title>
                        <v-card-subtitle :id="`subtitle_${i}`">{{d.content.description}}</v-card-subtitle>
                        <div
                            v-if="d.content.chart">
                            <div
                                style="position: absolute; right: 10px"
                                v-if="d.content.chart && d.content.chart.type == 'tableArea'">
                                <v-btn
                                    icon
                                    large
                                    @click="scrollTable(-1,`table_${i}`)">
                                    <v-icon>mdi-arrow-left</v-icon>
                                </v-btn>
                                <v-btn
                                    icon
                                    large
                                    @click="scrollTable(1,`table_${i}`)">
                                    <v-icon>mdi-arrow-right</v-icon>
                                </v-btn>
                            </div>
                            <div
                                v-if="dashboard_loading[i]"  
                                class="text-center"
                                style="padding: 32px 16px">
                                Carregando...
                            </div>
                            <div
                                v-else-if="!d.content.chart.data || d.content.chart.data.length <= 0"
                                class="text-center"
                                style="padding: 32px 16px">
                                Sem registro
                            </div>
                            <v-simple-table
                                width="100%"
                                :id="`table_${i}`"
                                class="table_view"
                                v-else-if="d.content.chart.type == 'tableArea'">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th 
                                                class="text-left"
                                                v-for="(cols,indexx) in d.content.chart.cols"
                                                :key="cols"
                                                :width="indexx == 0 ? '250px' : 'auto'">
                                                {{cols}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="item in d.content.chart.data"
                                            :key="item.name"
                                        >
                                            <td 
                                                style="height: 150px; width: 250px">
                                                <b>{{ item.name }}</b>
                                                <br/><br/>
                                                <small style="white-space: nowrap;">{{item.items.length}} equipamentos</small>
                                            </td>
                                            <td
                                                style="height: 150px; overflow: auto; white-space: nowrap;"
                                                class="table_tr">
                                                <div
                                                    v-for="its in item.items"
                                                    :key="its[d.content.chart.cars.id]"
                                                    style="display: inline-block; margin: 0px 10px">
                                                    <v-tooltip color="#f1f1f1" bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div
                                                            v-bind="attrs"
                                                            v-on="on">
                                                                <img :src="its[d.content.chart.cars.icon]" :style="`width:100px; height: 100px;transform: translate(${its[d.content.chart.cars.situacaoesIcon] ? '12px' : '0px'},0px)`"/>
                                                                <v-icon style="transform: translate(0px,-90px)">mdi-{{its[d.content.chart.cars.situacaoesIcon]}}</v-icon>
                                                                <div style="text-align: center">{{its[d.content.chart.cars.name]}}</div>
                                                            </div>
                                                        </template>
                                                        <span style="color: black" v-html="its[d.content.chart.cars.ballon]"></span>
                                                    </v-tooltip>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <pie-chart 
                                v-else-if="d.content.chart.type == 'pie'"
                                :data="d.content.chart.data">
                            </pie-chart>
                            <column-chart 
                                v-else-if="d.content.chart.type == 'column'"
                                :data="d.content.chart.data">
                            </column-chart>
                            <bar-chart 
                                v-else-if="d.content.chart.type == 'bar'"
                                :data="d.content.chart.data">
                            </bar-chart>
                            <line-chart 
                                v-else-if="d.content.chart.type == 'line'"
                                :data="d.content.chart.data">
                            </line-chart>
                            <area-chart 
                                v-else-if="d.content.chart.type == 'area'"
                                :data="d.content.chart.data">
                            </area-chart>
                            <v-simple-table
                                v-else-if="d.content.chart.type == 'ranking'"
                            >
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center">{{ d.content.chart.label1 }}</th>
                                            <th class="text-center"> {{ d.content.chart.label2 }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,i) in d.content.chart.data" :key="`item_${i}`">
                                            <td class="text-center" style="width: 50%">{{ item.value1 }}</td>
                                            <td class="text-center"  style="width: 50%">{{ item.value2 }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <fusioncharts
                                v-else-if="d.content.chart.type == 'multibar'"
                                type="msbar2d"
                                width="100%"
                                height="300"
                                dataFormat="json"
                                :dataSource="d.content.chart.data"
                            ></fusioncharts>
                            <fusioncharts
                                v-else-if="d.content.chart.type == 'multicolumn'"
                                type="msstackedcolumn2dlinedy"
                                width="100%"
                                height="300"
                                dataFormat="json"
                                :dataSource="d.content.chart.data"
                            ></fusioncharts>
                            <v-row align="center" justify="center" v-else-if="d.content.chart.type == 'double'">
                                <v-col lg="6" md="6" sm="6" cols="6" style="text-align:center; border-right: .5px solid #d2d2d2">
                                    <v-tooltip color="#f1f1f1" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div
                                            v-bind="attrs"
                                            v-on="on">
                                                <small style="font-weight: bold">{{d.content.chart.cols[0].text}}</small><br/>
                                                <v-icon x-large>{{d.content.chart.cols[0].icon}}</v-icon> {{d.content.chart.data.value1}}<br/>
                                            </div>
                                        </template>
                                        <span style="color: black" v-html="d.content.chart.data.balao1"></span>
                                    </v-tooltip>
                                </v-col>
                                <v-col lg="6" md="6" sm="6" cols="6" style="text-align:center; border-left: .5px solid #d2d2d2">
                                      <v-tooltip color="#f1f1f1" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div
                                            v-bind="attrs"
                                            v-on="on">
                                                <small style="font-weight: bold">{{d.content.chart.cols[1].text}}</small><br/>
                                                <v-icon x-large>{{d.content.chart.cols[1].icon}}</v-icon> {{d.content.chart.data.value2}}<br/>
                                            </div>
                                        </template>
                                        <span style="color: black" v-html="d.content.chart.data.balao2"></span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            <v-row align="center" justify="center" v-else-if="d.content.chart.type == 'horizontal'">
                                <v-col v-for="(item,item_index) in d.content.chart.data" :key="`data_${item_index}`"
                                    lg="2" md="2" sm="3" cols="4" style="text-align:center; border: .5px solid #d2d2d2">
                                    <v-tooltip color="#f1f1f1" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div
                                            v-bind="attrs"
                                            v-on="on">
                                                <small style="font-weight: bold">{{item.header}}</small><br/>
                                                <v-icon x-large>{{d.content.chart.icon}}</v-icon> {{item.value}}<br/>
                                                <small style="font-weight: bold">{{item.footer}}</small>
                                            </div>
                                        </template>
                                        <span style="color: black" v-html="item.balao"></span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            <div 
                                v-else-if="d.content.chart.type == 'gauge'">
                                <v-row align="center" justify="center">
                                    <v-col
                                        cols="6">
                                        <fusioncharts
                                            type="angulargauge"
                                            width="100%"
                                            height="150"
                                            dataFormat="json"
                                            :dataSource="d.content.chart.data.value1"
                                        ></fusioncharts>
                                    </v-col>
                                    <v-col
                                        cols="6">
                                        <fusioncharts
                                            type="angulargauge"
                                            width="100%"
                                            height="150"
                                            dataFormat="json"
                                            :dataSource="d.content.chart.data.value2"
                                        ></fusioncharts>
                                    </v-col>
                                </v-row>
                            </div>
                            <br/>
                        </div>
                        <div
                            v-if="d.content.icons" style="margin-top: -10px">
                            <v-row justify="center">
                                <v-col
                                    style="padding: 0px 8px"
                                    v-for="i in d.content.icons.items"
                                    :key="i.name"
                                    lg="6"
                                    md="6"
                                    sm="6"
                                    cols="6">
                                    <table style="width: 100%">
                                        <tr>
                                            <td rowspan="2" style="padding: 6px 8px; width: 50%" class="text-right">
                                                <v-icon x-large>{{i.icon}}</v-icon>
                                            </td>
                                            <td class="text-left" style="width: 50%; font-size: 14px">
                                                <b>{{i.label}}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left" style="width: 50%; font-size: 14px">
                                                {{i.value}}
                                            </td>
                                        </tr>
                                    </table>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-content>
    </div>
</template>

<style>
    html,body,#app{
        scroll-behavior: smooth;
    }
    .table_tr{
        scroll-behavior: smooth !important;
    }
    .table_view div table{
        scroll-behavior: smooth !important;
        table-layout:fixed !important
    }
    .table_view div table tr{
        scroll-behavior: smooth !important;
    }
</style>

<script>
import Navbar       from '@/components/Navbar.vue';
import router       from '@/router/index.js';
import api          from '@/plugins/apisauceHeader.js';

const meses = {
    "january": "Janeiro",
    "february": "Fevereiro",
    "march": "Março",
    "april": "Abril",
    "may": "Maio",
    "june": "Junho",
    "july": "Julho",
    "august": "Agosto",
    "september": "Setembro",
    "october": "Outubro",
    "november": "Novembro",
    "december": "Dezembro"
}

const semanas = {
    "sunday": "Domingo",
    "monday": "Segunda-Feira",
    "tuesday": "Terça-Feira",
    "wednesday": "Quarta-Feira",
    "thursday": "Quinta-Feira",
    "friday": "Sexta-Feira",
    "saturday": "Sábado"
}

export default {
    name: 'Dashboard',
    components:{
        Navbar
    },
    data: () => ({
        menu: false,
        ultima_att: new Date(),
        operacoes: [],
        maxPages: 1,
        page: 1,
        customization: {},
        usuario: {},
        headers: [
            { 
                "text": "Id Veiculo", 
                "value": "idveiculo", 
                "type": "number",
                "sortable": false,
                "required": true
            },
            { 
                "text": "Placa", 
                "value": "placa", 
                "sortable": false,
                "required": true
            },       
        ],
        dashboard_loading: [],
        dashboard_items: [],
        dashboard_data: [],
        reloading_charts: true,
        filtro: {},
        materiais: [],
        turnos: [],
        areas: [],
        periodos: [],
        filters: {},
        dashbaord_selecionado: {},
        dates: [],
        dialog_filtros: false,
        descarga: false,
        equipes: [],
        original_desc: []
    }),
    methods:{
        allowedDates(val){
            if(this.dates[0]){
                const date = new Date(val);
                const date2 = new Date(this.dates[0]);
                date2.setDate(date2.getDate() + 7);
                
                return parseInt(val.split('-')[1], 10) == this.dates[0].split("-")[1] && date < date2 && date >= new Date(this.dates[0]);
            }else
                return true;
        },
        recarregar(){
            this.dates = [];
            this.filtro = {
                area: [],
                turno: [],
                materiais: []
            }
            if(localStorage.getItem("dashbaord_selecionado"))
                this.dashbaord_selecionado = require("@/assets/func_dashboard.json")
            this.carregarDashboard(this.dashbaord_selecionado);
        },
        getFormatingDates(){
            const firstdate = this.dates[0] ? this.dates[0].split("-") : ['','',''];
            const seconddate = this.dates[1] ? this.dates[1].split("-") : ['','',''];
            return `${firstdate[2]}/${firstdate[1]}/${firstdate[0]} ~ ${seconddate[2]}/${seconddate[1]}/${seconddate[0]}`;
        },
        scrollTable(n){
            document.querySelector(`.table_tr`).scrollBy(n * 300,0);
        },
        salvarFiltros(){
            localStorage.setItem("filtro.data_inicio",this.dates[0]);
            localStorage.setItem("filtro.data_final",this.dates[1]);
            localStorage.setItem("filtro.itempq",JSON.stringify(this.filtro.materiais));
            localStorage.setItem("filtro.turno",JSON.stringify(this.filtro.turno));
            localStorage.setItem("filtro.equipes", JSON.stringify(this.filtro.equipes));
            localStorage.setItem("filtro.estruturas",JSON.stringify(this.filtro.area));
        },
        carregarDashboard(json){
            this.ultima_att = new Date();
            this.dashboard_items = [];
            this.dashboard_data = [];
            this.dashboard_loading = [];

            this.salvarFiltros();

            if(!json.items) json.items = json.itens;

            const itens = [];
            Object.keys(this.filtro).forEach(f=>{
                if(this.filtro[f].length == 0){
                    delete this.filtro[f];
                }
            })
            json.items.forEach((i)=>{
                if(i.content.onlyFilter && Object.keys(JSON.parse(JSON.stringify(this.filtro))).length != 0)
                    itens.push(i);
                else if(!i.content.onlyFilter)
                    itens.push(i);
            })

            itens.forEach((i,index)=>{
                this.dashboard_loading[index] = false;
                this.dashboard_data[index] = {};

                this.dashboard_items.push(i);

                if(i.content.querys){
                    this.dashboard_loading[index] = true;
                    this.carregarData(index,0);
                }

                if(i.content.chart){
                    const today = this.dates[0] ? new Date(this.dates[0]) : new Date();
                    if(this.dates[0])
                        today.setDate(today.getDate() + 1);
                    const tomorrow = this.dates[1] ? this.dates[1] == this.dates[0] ? today : new Date(this.dates[1]) : new Date(today)
                    if(this.dates[1] && this.dates[0] != this.dates[1])
                        tomorrow.setDate(tomorrow.getDate() + 1)

                    let diffDays  = 0;
                    let semInicio = new Date();
                    let semFinal  = new Date();
                    if(this.dates[1] && this.dates[0]){
                        const oneDay = 24 * 60 * 60 * 1000;
                        diffDays = Math.round(Math.abs((new Date(this.dates[1]) - new Date(this.dates[0])) / oneDay));
                    }
                    if(diffDays && diffDays == 6){
                        semInicio = new Date(this.dates[0]);
                        semInicio.setDate(semInicio.getDate() + 1);
                        semFinal = new Date(this.dates[1]);
                        semFinal.setDate(semFinal.getDate() + 1);
                    }else{
                        semInicio = new Date(this.dates[1] ? tomorrow : today);
                        semInicio.setDate(semInicio.getDate() - semInicio.getDay())
                        semFinal = new Date(this.dates[1] ? tomorrow : today);
                        semFinal.setDate(semFinal.getDate() + (6 - semFinal.getDay()));
                    }
                    const mesInicio = new Date(today);
                    mesInicio.setDate(1);
                    const mesFinal = new Date(today);
                    mesFinal.setMonth(mesFinal.getMonth() + 1);
                    mesFinal.setDate(1);
                    const anoInicio = new Date(this.dates[1] ? tomorrow : today);
                    anoInicio.setDate(1);
                    anoInicio.setMonth(0);
                    const anoFinal = new Date(this.dates[1] ? tomorrow : today);
                    anoFinal.setDate(1);
                    anoFinal.setMonth(0);
                    anoFinal.setFullYear(anoFinal.getFullYear() + 1);

                    this.dashboard_items[index].content.title = i.content.title
                        .replace("CARGA",this.descarga ? "DESCARGA" : "CARGA")
                    if(Object.keys(JSON.parse(JSON.stringify(this.filtro))).length != 0)
                        this.dashboard_items[index].content.description = this.original_desc[index]
                            .replace("carga",this.descarga ? "descarga" : "carga")
                            .replace("{hoje}", `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`)
                            .replace("{amanha}", `${tomorrow.getDate()}/${tomorrow.getMonth() + 1}/${tomorrow.getFullYear()}`)
                            .replace("{semInicio}", `${semInicio.getDate()}/${semInicio.getMonth() + 1}/${semInicio.getFullYear()}`)
                            .replace("{semFinal}", `${semFinal.getDate()}/${semFinal.getMonth() + 1}/${semFinal.getFullYear()}`)
                            .replace("{mes}",meses[Object.keys(meses)[mesInicio.getMonth()]])
                            .replace("{mesInicio}", `${mesInicio.getDate()}/${mesInicio.getMonth() + 1}/${mesInicio.getFullYear()}`)
                            .replace("{mesFinal}", `${mesFinal.getDate()}/${mesFinal.getMonth() + 1}/${mesFinal.getFullYear()}`)
                            .replace("{ano}",anoInicio.getFullYear())
                            .replace("{anoInicio}", `${anoInicio.getDate()}/${anoInicio.getMonth() + 1}/${anoInicio.getFullYear()}`)
                            .replace("{anoFinal}", `${anoFinal.getDate()}/${anoFinal.getMonth() + 1}/${anoFinal.getFullYear()}`)
                
                    /*if(document.getElementById("subtitle_1"))
                        document.getElementById("subtitle_1").innerText = document.getElementById("subtitle_1").innerText
                            .replace("{semInicio}", `${semInicio.getDate()}/${semInicio.getMonth() + 1}/${semInicio.getFullYear()}`)
                            .replace("{semFinal}", `${semFinal.getDate()}/${semFinal.getMonth() + 1}/${semFinal.getFullYear()}`)*/

                    this.dashboard_loading[index] = true;
                    let url = i.content.chart.needWhere ? `endpoint/${i.content.chart.url}/addwhere=idcliente:${localStorage.getItem("idcliente")}` : `endpoint/${i.content.chart.url},fuso:${-(new Date().getTimezoneOffset() / 60)}`;
                    url = url
                        .replace("{idcliente}",localStorage.getItem("idcliente"))
                        .replace("{hoje}", `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`)
                        .replace("{amanha}", `${tomorrow.getFullYear()}-${tomorrow.getMonth() + 1}-${tomorrow.getDate()}`)
                        .replace("{semInicio}", `${semInicio.getFullYear()}-${semInicio.getMonth() + 1}-${semInicio.getDate()}`)
                        .replace("{semFinal}", `${semFinal.getFullYear()}-${semFinal.getMonth() + 1}-${semFinal.getDate()}`)
                        .replace("{mesInicio}", `${mesInicio.getFullYear()}-${mesInicio.getMonth() + 1}-${mesInicio.getDate()}`)
                        .replace("{mesFinal}", `${mesFinal.getFullYear()}-${mesFinal.getMonth() + 1}-${mesFinal.getDate()}`)
                        .replace("{anoInicio}", `${anoInicio.getFullYear()}-${anoInicio.getMonth() + 1}-${anoInicio.getDate()}`)
                        .replace("{anoFinal}", `${anoFinal.getFullYear()}-${anoFinal.getMonth() + 1}-${anoFinal.getDate()}`)
                    if(this.filtro.materiais && this.filtro.materiais.length > 0)
                        url += `,iditempq:[${this.filtro.materiais.map(m=>{return `${m.iditempq}`}).join(",")}]`;
                    if(this.filtro.turno && this.filtro.turno.length > 0)
                        url += `,idturno:[${this.filtro.turno.map(m=>{return `${m.idturno}`}).join(",")}]`;
                    if(this.filtro.area && this.filtro.area.length > 0)
                        url += `,idestrutura:[${this.filtro.area.map(m=>{return `${m.idestrutura}`}).join(",")}]`;
                    if(this.filtro.equipes && this.filtro.equipes.length > 0)
                        url += `,idequipe:[${this.filtro.equipes.map(m=>{return `${m.idequipe}`}).join(",")}]`;
                    url += '?noPagination=true';
                    api(localStorage.getItem("token")).get(url).then(r=>{
                        if(r.ok){
                            let rows;
                            if(i.content.chart.type != "tableArea")
                                rows = Object.keys(r.data.endpoint[0]).map(m=>{
                                    return r.data.endpoint[0][m];
                                });
                            if(i.content.chart.type == "multibar")
                                i.content.chart.data = {
                                    "chart": {
                                        "placevaluesInside": "1",
                                        "xAxisLineColor": "#999999",
                                        "formatNumberScale": "0",
                                        "theme": "fusion",
                                        "showValues": "1"
                                    },
                                    "categories": [
                                        {
                                            "category": rows.map(m=>{
                                                return {
                                                    "label": m[i.content.chart.nameColumn]
                                                }  
                                            })
                                        }
                                    ],
                                    "dataset": i.content.chart.cols.map(m=>{
                                        return  {
                                            seriesname: m.label,
                                            color: m.color,
                                            data: rows.map(ro=>{
                                                return {
                                                    "value":  (this.descarga && m.name2) ? ro[m.name2] : ro[m.name]   
                                                }
                                            })
                                        }
                                    })
                                }
                            else if(i.content.chart.type == "horizontal"){
                                i.content.chart.data = rows.map(m=>{
                                    return {
                                        header: m[i.content.chart.headerColumn],
                                        footer: m[i.content.chart.footerColumn],
                                        value: m[i.content.chart.valueColumn],
                                        balao: m[i.content.chart.balaoColumn].length > 0 ? `<b>Funcionários:</b> <br>${m[i.content.chart.balaoColumn]}` : ""
                                    }
                                });
                            }else if(i.content.chart.type == "double"){
                                i.content.chart.data = {
                                    value1: r.data.endpoint[0][0][i.content.chart.cols[0].value],
                                    value2: r.data.endpoint[0][0][i.content.chart.cols[1].value],
                                    balao1: r.data.endpoint[0][0][i.content.chart.cols[0].balao].length > 0 ? `<b>Funcionários:</b> <br>${r.data.endpoint[0][0][i.content.chart.cols[0].balao]}` : "",
                                    balao2: r.data.endpoint[0][0][i.content.chart.cols[1].balao].length > 0 ? `<b>Funcionários:</b> <br>${r.data.endpoint[0][0][i.content.chart.cols[1].balao]}` : "",
                                };
                            }else if(i.content.chart.type == "debug")
                                console.log(r.data);
                            else if(i.content.chart.type == "gauge"){
                                i.content.chart.data = {
                                    value1: {
                                        "chart": {
                                            "caption": i.content.chart.label1,
                                            "lowerLimit": "0",
                                            "upperLimit": "100",
                                            "numberSuffix": "%",
                                            "theme": "fusion"
                                        },
                                        "colorRange": {
                                            "color": [
                                                {
                                                    "minValue": "0",
                                                    "maxValue": "50",
                                                    "label": "Low",
                                                    "code": "#c02d00"
                                                },
                                                {
                                                    "minValue": "50",
                                                    "maxValue": "75",
                                                    "label": "Moderate",
                                                    "code": "#f2c500"
                                                },
                                                {
                                                    "minValue": "75",
                                                    "maxValue": "100",
                                                    "label": "High",
                                                    "code": "#1aaf5d"
                                                }
                                            ]
                                        },
                                        "pointers": {
                                            "pointer": [
                                                {
                                                    "value": rows[0][i.content.chart.column1]
                                                }
                                            ]
                                        }
                                    },
                                    value2: {
                                        "chart": {
                                            "caption": i.content.chart.label2,
                                            "lowerLimit": "0",
                                            "upperLimit": "100",
                                            "numberSuffix": "%",
                                            "theme": "fusion"
                                        },
                                        "colorRange": {
                                            "color": [
                                                {
                                                    "minValue": "0",
                                                    "maxValue": "50",
                                                    "label": "Low",
                                                    "code": "#c02d00"
                                                },
                                                {
                                                    "minValue": "50",
                                                    "maxValue": "75",
                                                    "label": "Moderate",
                                                    "code": "#f2c500"
                                                },
                                                {
                                                    "minValue": "75",
                                                    "maxValue": "100",
                                                    "label": "High",
                                                    "code": "#1aaf5d"
                                                }
                                            ]
                                        },
                                        "pointers": {
                                            "pointer": [
                                                {
                                                    "value": rows[0][i.content.chart.column2]
                                                }
                                            ]
                                        }
                                    }
                                }
                            }else if(i.content.chart.type == "multicolumn")
                                i.content.chart.data = {
                                    "chart": {
                                        "theme": "fusion",
                                        "formatNumberScale": "0",
                                        "labelDisplay": i.content.chart.labelDisplay ? i.content.chart.labelDisplay : "auto" 
                                    },
                                    "categories": [
                                        {
                                            "category": rows.map(m=>{
                                                let label = m[i.content.chart.nameColumn].toString();
                                                if(label && Object.keys(meses).includes(label.toLowerCase()))
                                                    label = meses[label.toLowerCase()];
                                                else if(label && Object.keys(semanas).includes(label.toLowerCase()))
                                                    label = semanas[label.toLowerCase()];
                                                return {
                                                    label
                                                }
                                            })
                                        }
                                    ],
                                    "dataset": i.content.chart.rows.map(m=>{
                                        return {
                                            dataset:[
                                                {
                                                    seriesname: m.label,
                                                    color: m.color,
                                                    data: rows.map(m2=>{
                                                        return {
                                                            value: (this.descarga && m.name2) ? m2[m.name2] : m2[m.name]
                                                        };
                                                    })
                                                }
                                            ]
                                        }
                                    }),
                                    "lineset": i.content.chart.lines.map(m=>{
                                        return {
                                            seriesname: m.label,
                                            color: m.color,
                                            showValues: "0",
                                            data: rows.map(m2=>{
                                                return {
                                                    value: (this.descarga && m.name2) ? m2[m.name2] : m2[m.name]
                                                }
                                            })
                                        }
                                    })
                                }
                            else if(i.content.chart.type == "ranking"){
                                let url2 = i.content.chart.needWhere ? `endpoint/${i.content.chart.url2}/addwhere=idcliente:${localStorage.getItem("idcliente")}?noPagination=true` : `endpoint/${i.content.chart.url2}?noPagination=true`;
                                url2 = url2
                                    .replace("{idcarga}",i.content.chart.idcarga)
                                    .replace("{idcliente}",localStorage.getItem("idcliente"))
                                    .replace("{hoje}", `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`)
                                    .replace("{amanha}", `${tomorrow.getFullYear()}-${tomorrow.getMonth() + 1}-${tomorrow.getDate()}`)
                                api(localStorage.getItem("token")).get(url2).then(r2=>{
                                    if(r2.ok){
                                        const rows2 = Object.keys(r.data.endpoint[0]).map(m=>{
                                            return r2.data.endpoint[0][m];
                                        });
                                        i.content.chart.data = [];
                                        for(let x = 0; x < i.content.chart.limit; x++){
                                            i.content.chart.data.push({
                                                value1: rows[x] ? rows[x][i.content.chart.nameColumn1] : "",
                                                value2: rows2[x] ? rows2[x][i.content.chart.nameColumn2] : ""
                                            })
                                        }
                                        if(rows.length == 0 && rows2.length == 0)
                                            i.content.chart.data = [];
                                        this.dashboard_loading[index] = false;
                                        this.$forceUpdate();
                                    }
                                })
                            }else if(i.content.chart.type == "tableArea"){
                                const rs = r.data.endpoint;
                                const rs2 = [];
                                rs.forEach(rp=>{
                                    if(rp[i.content.chart.cars.idver]){
                                        if(rp[i.content.chart.cars.icon])
                                            rp[i.content.chart.cars.icon] = new Buffer(rp[i.content.chart.cars.icon].data).toString();
                                        let has = false;
                                        for(let x = 0; x < rs2.length; x++){
                                            if(rs2[x].id == rp[i.content.chart.idColumn]){
                                                rs2[x].items.push(rp);
                                                has = true;
                                                break;
                                            }
                                        }
                                        if(!has)
                                            rs2.push({
                                                id: rp[i.content.chart.idColumn],
                                                name: rp[i.content.chart.nameColumn],
                                                items: [ rp ]
                                            })
                                    }
                                })
                                i.content.chart.data = rs2;
                                this.dashboard_loading[index] = false;
                                this.$forceUpdate();
                            }else{
                                let allEmpty = true;
                                i.content.chart.data = rows.map(m=>{
                                    if(["pie","column","bar"].includes(i.content.chart.type)){
                                        if(m[i.content.chart.valueColumn] != 0 && m[i.content.chart.valueColumn] != "00:00:00") allEmpty = false;
                                        return [
                                            m[i.content.chart.nameColumn],
                                            m[i.content.chart.valueColumn]
                                        ]
                                    }else{
                                        let obj = {};
                                        obj[m[i.content.chart.nameColumn]] = parseFloat(m[i.content.chart.valueColumn]);
                                        return obj;
                                    }
                                })
                                if(allEmpty) i.content.chart.data = [];
                            }
                        }
                        this.dashboard_loading[index] = false;
                        this.$forceUpdate();
                    });
                }
            
                if(i.content.icons){
                    const today = this.dates[0] ? new Date(this.dates[0]) : new Date();
                    if(this.dates[0])
                        today.setDate(today.getDate() + 1);
                    const tomorrow = this.dates[1] ? this.dates[1] == this.dates[0] ? today : new Date(this.dates[1]) : new Date(today)
                    if(this.dates[1] && this.dates[0] != this.dates[1])
                        tomorrow.setDate(tomorrow.getDate() + 1)
                    let url = `endpoint/${i.content.icons.url}`
                        .replace("{idcliente}",localStorage.getItem("idcliente"))
                        .replace("{hoje}", `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`)
                        .replace("{amanha}", `${tomorrow.getFullYear()}-${tomorrow.getMonth() + 1}-${tomorrow.getDate()}`)
                    if(this.filtro.materiais && this.filtro.materiais.length > 0)
                        url += `,iditempq:[${this.filtro.materiais.map(m=>{return `${m.iditempq}`}).join(",")}]`;
                    if(this.filtro.turno && this.filtro.materiais.length > 0)
                        url += `,idturno:[${this.filtro.turno.map(m=>{return `${m.idturno}`}).join(",")}]`;
                    if(this.filtro.area && this.filtro.area.length > 0)
                        url += `,idestrutura:[${this.filtro.area.map(m=>{return `${m.idestrutura}`}).join(",")}]`;
                    if(this.filtro.equipes && this.filtro.equipes.length > 0)
                        url += `,idequipe:[${this.filtro.equipes.map(m=>{return `${m.idequipe}`}).join(",")}]`;
                    url += '?noPagination=true';
                    api(localStorage.getItem("token")).get(url).then(r=>{
                        if(r.ok){
                            i.content.icons.items.forEach(ico=>{
                                ico.value = r.data.endpoint[0][0][ico.name] ? r.data.endpoint[0][0][ico.name] : 0
                            })
                        }
                        this.dashboard_loading[index] = false;
                        this.$forceUpdate();
                    })   
                }
            })
            this.$forceUpdate();
        },
        carregarData(i,n){
            const querrysList = Object.keys(this.dashboard_items[i].content.querys);
            const querys = this.dashboard_items[i].content.querys;
            const qn = querrysList[n];
            if(querrysList.length > n){
                const query = querys[qn]; 
                const url = querys[qn].needWhere ? `endpoint/${querys[qn].url}/addwhere=idcliente:${localStorage.getItem("idcliente")}` : `endpoint/${querys[qn].url}`;
                api(localStorage.getItem("token")).get(url).then(r=>{
                    if(r.ok)
                        this.dashboard_data[i][qn] = r.data.endpoint[query.index ? query.index : 0][query.column];
                    
                    this.dashboard_items[i].content.title = this.dashboard_items[i].content.title.replace("{{"+qn+"}}",this.dashboard_data[i][qn]);
                    this.dashboard_items[i].content.description = this.dashboard_items[i].content.description.replace("{{"+qn+"}}",this.dashboard_data[i][qn]);
                    this.carregarData(i,n+1);
                })
            }else 
                this.dashboard_loading[i] = false;
        },
        getFiltros(){
            if(localStorage.getItem("filtro.data_inicio") && localStorage.getItem("filtro.data_inicio") != "undefined")
                this.dates[0] = localStorage.getItem("filtro.data_inicio");
            if(localStorage.getItem("filtro.data_final") && localStorage.getItem("filtro.data_final") != "undefined")
                this.dates[1] = localStorage.getItem("filtro.data_final");

            api(localStorage.getItem("token"))
                .get(`endpoint/itempqAll/addwhere=idcliente:${localStorage.getItem("idcliente")}?noPagination=true`)
                .then(r=>{
                    if(r.ok)
                        this.materiais = r.data.endpoint;
                    if(localStorage.getItem("filtro.itempq") && localStorage.getItem("filtro.itempq") != "undefined")
                        this.filtro.materiais = JSON.parse(localStorage.getItem("filtro.itempq"));
                })
                
            api(localStorage.getItem("token"))
                .get(`endpoint/getTurno/addwhere=idcliente:${localStorage.getItem("idcliente")}?noPagination=true`)
                .then(r=>{
                    if(r.ok)
                        this.turnos = r.data.endpoint;
                    if(localStorage.getItem("filtro.turno") && localStorage.getItem("filtro.turno") != "undefined")
                        this.filtro.turno = JSON.parse(localStorage.getItem("filtro.turno"));
                })

            api(localStorage.getItem("token"))
                .get(`endpoint/estruturasAll/addwhere=idcliente:${localStorage.getItem("idcliente")}?noPagination=true`)
                .then(r=>{
                    if(r.ok)
                        this.areas = r.data.endpoint;

                    if(localStorage.getItem("filtro.estruturas") && localStorage.getItem("filtro.estruturas") != "undefined")
                        this.filtro.area = JSON.parse(localStorage.getItem("filtro.estruturas"));
                })


            api(localStorage.getItem("token"))
                .get(`endpoint/cadequipesall/addwhere=idcliente:${localStorage.getItem("idcliente")}?noPagination=true`)
                .then(r=>{
                    if(r.ok)
                        this.equipes = r.data.endpoint;

                    if(localStorage.getItem("filtro.equipes") && localStorage.getItem("filtro.equipes") != "undefined")
                        this.filtro.equipes = JSON.parse(localStorage.getItem("filtro.equipes"));
                })


            setTimeout(() => {
                this.carregarDashboard(this.dashbaord_selecionado);
            }, 1000);
        },
        filtrar(){
            this.dialog_filtros = false;
            this.dashbaord_selecionado = require("@/assets/func_dashboard.json");
            this.carregarDashboard(this.dashbaord_selecionado);
        }
    },
    mounted(){
        if(!localStorage.getItem("usrId")) router.push('/');
        this.customization = JSON.parse(localStorage.getItem("customization"));
        document.title = `${this.customization.name} - Dashboard`;

        this.dashbaord_selecionado = require("@/assets/func_dashboard.json");
        this.dashbaord_selecionado.items.forEach(i=>{
            this.original_desc.push(i.content.description)
        })

        this.usuario = {
            nome:   localStorage.getItem("nome"),
            conta:  localStorage.getItem("account")
        };

        setInterval(()=>{
            if(this.reloading_charts && !this.dashbaord_selecionado.refresh)
                this.carregarDashboard(this.dashbaord_selecionado);
        },1000 * 60 * 10)
        setInterval(()=>{
            if(this.dashbaord_selecionado.refresh)
                this.carregarDashboard(this.dashbaord_selecionado);
        },1000 * 60 * 1)

        this.getFiltros();
    }
}
</script>